import { PaletteOptions } from '@mui/material'

export const palette: PaletteOptions = {
  primary: { main: '#6b3248', light: 'rgba(160, 89, 116, .23)' },
  secondary: { main: '#3c9095' },
  grey: { 400: '#ebecf1' },
  text: { primary: '#4a5459' },
}
